import { CButton, CContainer } from '@coreui/react'
import { Link } from 'react-router-dom'
export function NotFoundPage() {
  return (
    <main className="not-found">
      <CContainer>
        <span className="eyebrow">404</span>
        <h1>This Observatory route does not exist.</h1>
        <p>The public machine record is still available from the homepage.</p>
        <CButton color="primary" as={Link} to="/">
          Return home
        </CButton>
      </CContainer>
    </main>
  )
}
